// hooks/useExportFormats.ts
import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';
import {
  getSupportedFormats,
  SUPPORTING_EXPORT_FORMATS,
} from '@/components/organism/ExportDataModal/export.types';

type PageKeyType = keyof typeof SUPPORTING_EXPORT_FORMATS;

export const useExportFormats = (pageKey: PageKeyType) => {
  const [searchParams] = useSearchParams();
  const isDebug = searchParams.get('debug') === 'true';

  const formats = useMemo(() => {
    return getSupportedFormats(pageKey, isDebug);
  }, [pageKey, isDebug]);

  return formats;
};
